import spacing from './spacing'
import palette from './palette'
import typography from './typography'
import dimensions from './dimensions'
import beWise from './beWise'

const R = { palette, spacing, typography, dimensions, beWise }

export default R
